const escapeRegExp = (valor: string) => valor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const gerarSlug = (valor: string) =>
  valor
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .toLowerCase();

export const calcularSlugSequencial = (slugBase: string, existentes: string[]): string => {
  if (!slugBase) return '';

  const conjunto = new Set(existentes);
  if (!conjunto.has(slugBase)) {
    return slugBase;
  }

  const escaped = escapeRegExp(slugBase);
  const regexDigitos = new RegExp(`^${escaped}(\\d+)$`);
  const regexHifen = new RegExp(`^${escaped}-(\\d+)$`);

  let maxDigitos = 0;
  let maxHifen = 0;

  existentes.forEach((slugExistente) => {
    if (slugExistente === slugBase) {
      return;
    }

    const matchDigitos = regexDigitos.exec(slugExistente);
    if (matchDigitos) {
      const numero = Number.parseInt(matchDigitos[1], 10);
      if (!Number.isNaN(numero)) {
        maxDigitos = Math.max(maxDigitos, numero);
      }
      return;
    }

    const matchHifen = regexHifen.exec(slugExistente);
    if (matchHifen) {
      const numero = Number.parseInt(matchHifen[1], 10);
      if (!Number.isNaN(numero)) {
        maxHifen = Math.max(maxHifen, numero);
      }
    }
  });

  const gerarCandidato = (separador: '' | '-', inicio: number) => {
    let numeroAtual = Math.max(inicio, 2);
    let candidato = separador === '-' ? `${slugBase}-${numeroAtual}` : `${slugBase}${numeroAtual}`;
    while (conjunto.has(candidato)) {
      numeroAtual += 1;
      candidato = separador === '-' ? `${slugBase}-${numeroAtual}` : `${slugBase}${numeroAtual}`;
    }
    return candidato;
  };

  if (maxDigitos > 0 || maxHifen === 0) {
    const inicioDigits = maxDigitos > 0 ? maxDigitos + 1 : 2;
    return gerarCandidato('', inicioDigits);
  }

  const inicioHifen = maxHifen > 0 ? maxHifen + 1 : 2;
  return gerarCandidato('-', inicioHifen);
};

export const sugerirSlugAutomatico = (titulo: string, existentes: string[]): string => {
  const base = gerarSlug(titulo);
  if (!base) return '';
  return calcularSlugSequencial(base, existentes);
};
